import React, { Fragment } from "react";
import "./spinner.css";
import * as utils from "../utils";

const Spinner = ({ size = "large", active = true }) => {
  const spinnerPosition = utils.getSpinnerPosition();
  const style = { ...spinnerPosition };
  return (
    <Fragment>
      {active ? (
        <div className='loader-wrapper'>
          <div className={`spinner spinner-${size} green bg-white`} style={style} />
        </div>
      ) : null}
    </Fragment>
  );
};

export default Spinner;
